module.exports = __webpack_public_path__ + "static/media/06.47e0a581.png";